/** Catalogue and status vocabulary shared across the client, provider and admin areas. */

export const SERVICE_CATALOG = [
  {
    id: '1',
    name: 'Nettoyage',
    image: '/assets/illustrations/nettoyage.png',
    tint: 'var(--svc-nettoyage)',
  },
  {
    id: '2',
    name: 'Jardinage',
    image: '/assets/illustrations/jardinage.png',
    tint: 'var(--svc-jardinage)',
  },
  {
    id: '3',
    name: 'Déménagement',
    image: '/assets/illustrations/demenagement.png',
    tint: 'var(--svc-demenagement)',
  },
  {
    id: '4',
    name: 'Lavage auto',
    image: '/assets/illustrations/lavage-auto.png',
    tint: 'var(--svc-lavage)',
  },
] as const;

export const SERVICE_NAMES = SERVICE_CATALOG.map((service) => service.name);

const serviceEntry = (name: string) =>
  SERVICE_CATALOG.find((service) => service.name === name) ?? SERVICE_CATALOG[0];

export const serviceImage = (name: string) => serviceEntry(name).image;

/** Pastel ground the service illustration sits on. */
export const serviceTint = (name: string) => serviceEntry(name).tint;

export const TIME_SLOTS = [
  '08:00',
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
];

/** Stored in `bookings.preferred_time` when the client wants the first available slot. */
export const ASAP_TIME = 'Dès que possible';

export type BookingStatus =
  | 'pending'
  | 'assigned'
  | 'accepted'
  | 'in_progress'
  | 'pending_review'
  | 'completed'
  | 'cancelled'
  | 'rejected';

/** `color` is the badge ink: dark enough to read on its own 12% tint. */
export const STATUS_META: Record<string, { label: string; color: string }> = {
  pending: { label: 'En attente', color: '#9a5b00' },
  assigned: { label: 'Assigné', color: '#b85400' },
  accepted: { label: 'Accepté', color: '#2459c9' },
  in_progress: { label: 'En cours', color: '#6a3fc7' },
  pending_review: { label: 'À évaluer', color: '#b83a74' },
  completed: { label: 'Terminé', color: '#0a7a54' },
  cancelled: { label: 'Annulé', color: '#5b6272' },
  rejected: { label: 'Rejeté', color: '#c5282e' },
};

export const statusMeta = (status: string) =>
  STATUS_META[status] ?? { label: status, color: '#5b6272' };

export const BOOKING_STEPS = [
  { status: 'pending', label: 'Demande envoyée' },
  { status: 'assigned', label: 'Prestataire sélectionné' },
  { status: 'accepted', label: 'Accepté par le prestataire' },
  { status: 'in_progress', label: 'En cours' },
  { status: 'pending_review', label: "En attente d'avis" },
  { status: 'completed', label: 'Terminé' },
];

export const SUPPORT_PHONE = '+212636982168';
export const SUPPORT_PHONE_DISPLAY = '+212 6 36 98 21 68';
